import { render, staticRenderFns } from "./AccountPayable.vue?vue&type=template&id=1287445b&"
import script from "./AccountPayable.vue?vue&type=script&lang=js&"
export * from "./AccountPayable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports